import { render } from "./CategoryView.vue?vue&type=template&id=1ac3e5f6&scoped=true"
import script from "./CategoryView.vue?vue&type=script&lang=js"
export * from "./CategoryView.vue?vue&type=script&lang=js"

import "./CategoryView.vue?vue&type=style&index=0&id=1ac3e5f6&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1ac3e5f6"

export default script